import React from "react";
import DownloadApp from "@/components/common/DownloadApp";
import styles from "../Footer.module.scss";
import Image from "next/image";
import QRCode from "public/images/QR_Code/qr-code.svg";

const FooterAppDownload = () => {
  return (
    <div className={styles.footerAppDownload_wrapper}>
      <div className={styles.appDownloadSection}>
        {/* Existing Download App Button */}
        <DownloadApp/>

        {/* QR Code for App Download */}
        <div className={styles.qrCodeSection}>
          <Image
            src={QRCode}
            alt="QR Code for downloading the iOS app"
            width={80}
            height={80}
            className={styles.qrCodeImage}
            priority
          />
        </div>
      </div>
    </div>
  );
};

export default FooterAppDownload;